document.documentElement.classList.remove("no-js");

const menuButton = document.querySelector("[data-menu-button]");
const menu = document.querySelector("[data-menu]");

if (menuButton && menu) {
  const closeMenu = () => {
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", menuButton.dataset.labelOpen || "Menu");
    menu.classList.remove("is-open");
  };

  menuButton.addEventListener("click", () => {
    const open = menuButton.getAttribute("aria-expanded") === "true";
    menuButton.setAttribute("aria-expanded", String(!open));
    menuButton.setAttribute("aria-label", open
      ? (menuButton.dataset.labelOpen || "Menu")
      : (menuButton.dataset.labelClose || "Close")
    );
    menu.classList.toggle("is-open", !open);
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      closeMenu();
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && menu.classList.contains("is-open")) {
      closeMenu();
      menuButton.focus();
    }
  });

  document.addEventListener("click", (event) => {
    if (menu.classList.contains("is-open") && !menu.contains(event.target) && !menuButton.contains(event.target)) {
      closeMenu();
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 990) closeMenu();
  });
}

document.querySelectorAll("[data-language-selector]").forEach((select) => {
  select.addEventListener("change", () => select.form?.submit());
});

document.querySelectorAll("[data-cookie-preferences]").forEach((link) => {
  link.addEventListener("click", (event) => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      event.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  const variantSelect = form.querySelector('select[name="id"]');
  const productPrice = document.getElementById("ProductPrice");

  if (variantSelect && productPrice) {
    variantSelect.addEventListener("change", () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const price = selectedOption?.dataset.price;
      const priceValue = productPrice.querySelector("span");
      if (price && priceValue) priceValue.textContent = price;
    });
  }

  form.addEventListener("submit", () => {
    const button = form.querySelector(".product-form__submit");
    if (button) {
      button.setAttribute("aria-busy", "true");
    }
  });
});

document.querySelectorAll("[data-free-download]").forEach((control) => {
  control.addEventListener("click", () => {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish("free_download", {
        product_id: control.dataset.productId || "",
        product_handle: control.dataset.productHandle || "",
        delivery: control.hasAttribute("data-free-download-fallback") ? "checkout" : "direct"
      });
    }
  });
});

const publishFreeDownloadEvent = (eventName, source, extra = {}) => {
  const payload = {
    event: eventName,
    product_id: source?.dataset.productId || "",
    product_handle: source?.dataset.productHandle || "",
    locale: source?.dataset.locale || document.documentElement.lang || "",
    ...extra
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish(eventName, payload);
  }
};

const downloadFreeFile = async (urlValue) => {
  const url = new URL(urlValue, window.location.href);
  if (url.protocol !== "https:" && url.protocol !== "http:") throw new Error("Unsupported download URL");
  if (!window.fetch || !window.AbortController || !window.URL?.createObjectURL ||
      !("download" in document.createElement("a"))) {
    window.location.assign(url.href);
    return "navigation";
  }

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 30000);
  let blobUrl;
  let downloadLink;
  try {
    const response = await fetch(url.href, { mode: "cors", credentials: "omit", signal: controller.signal });
    if (!response.ok) throw new Error("Download request failed");
    const blob = await response.blob();
    if (!blob.size || /(?:text\/html|application\/xhtml\+xml)/i.test(blob.type)) throw new Error("Empty file or delivery page");
    let filename = url.pathname.split("/").pop() || "download.pdf";
    try { filename = decodeURIComponent(filename); } catch (_) { /* Keep encoded name. */ }
    filename = filename.replace(/[\/\\:*?"<>|\x00-\x1f]/g, "_");
    blobUrl = URL.createObjectURL(blob);
    downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = filename;
    downloadLink.hidden = true;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    return "blob";
  } catch (_) {
    window.location.assign(url.href);
    return "navigation";
  } finally {
    window.clearTimeout(timeout);
    if (downloadLink) downloadLink.remove();
    if (blobUrl) window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  }
};

document.querySelectorAll("[data-free-download-gate]").forEach((gate) => {
  const opener = document.querySelector("[data-free-download-gate-open]");
  const closeButton = gate.querySelector("[data-free-download-gate-close]");
  const form = gate.closest("form");

  const openGate = () => {
    if (typeof gate.showModal === "function") gate.showModal();
    else gate.setAttribute("open", "");
    document.body.classList.add("free-download-gate-open");
  };
  const closeGate = () => {
    if (typeof gate.close === "function") gate.close();
    else gate.removeAttribute("open");
    document.body.classList.remove("free-download-gate-open");
  };

  opener?.addEventListener("click", () => {
    publishFreeDownloadEvent("free_download_gate_open", gate);
    openGate();
  });
  closeButton?.addEventListener("click", closeGate);
  gate.addEventListener("click", (event) => { if (event.target === gate) closeGate(); });
  gate.addEventListener("cancel", () => document.body.classList.remove("free-download-gate-open"));
  form?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton?.getAttribute("aria-busy") === "true") return;
    if (submitButton) submitButton.setAttribute("aria-busy", "true");
    publishFreeDownloadEvent("free_download_email_submit", gate, {
      marketing_consent: Boolean(form.querySelector('input[name="contact[accepts_marketing]"]')?.checked)
    });

    // Submit to Shopify without allowing its response or redirect to replace
    // the storefront page. The request remains a native Shopify form POST.
    const submissionFrame = document.createElement("iframe");
    submissionFrame.name = `FreeDownloadSubmission-${Date.now()}`;
    submissionFrame.hidden = true;
    submissionFrame.setAttribute("aria-hidden", "true");
    document.body.appendChild(submissionFrame);
    form.target = submissionFrame.name;
    HTMLFormElement.prototype.submit.call(form);

    // Keep this click in the original user gesture. Cross-origin CDNs may
    // ignore the download attribute; target=_blank then preserves the store.
    const downloadLink = document.createElement("a");
    downloadLink.href = gate.dataset.downloadUrl;
    downloadLink.download = "";
    downloadLink.target = "_blank";
    downloadLink.rel = "noopener";
    downloadLink.hidden = true;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();

    publishFreeDownloadEvent("free_download_success", gate, { delivery: "download_or_new_tab" });
    const panel = form.querySelector(".free-download-gate__panel");
    if (panel) {
      panel.replaceChildren();

      const successClose = document.createElement("button");
      successClose.className = "free-download-gate__close";
      successClose.type = "button";
      successClose.setAttribute("aria-label", closeButton?.getAttribute("aria-label") || "Close");
      successClose.textContent = "×";
      successClose.addEventListener("click", closeGate);

      const thankYou = document.createElement("div");
      thankYou.className = "free-download-gate__thank-you";
      thankYou.setAttribute("role", "status");

      const mark = document.createElement("span");
      mark.className = "free-download-gate__thank-you-mark";
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = "✓";

      const title = document.createElement("h2");
      title.tabIndex = -1;
      title.textContent = gate.dataset.thankYouTitle || "Thank you for downloading.";

      const body = document.createElement("p");
      body.textContent = gate.dataset.thankYouBody || gate.dataset.successMessage || "Download started.";

      const productsLink = document.createElement("a");
      productsLink.className = "button button-primary";
      productsLink.href = gate.dataset.productsUrl || "/collections/all";
      productsLink.textContent = gate.dataset.productsLabel || "View other products";

      thankYou.append(mark, title, body, productsLink);
      panel.append(successClose, thankYou);
      title.focus();
    }
    if (submitButton) submitButton.removeAttribute("aria-busy");
    window.setTimeout(() => submissionFrame.remove(), 60000);
  });

  if (gate.hasAttribute("data-has-errors")) openGate();
  if (gate.hasAttribute("data-posted-successfully")) {
    openGate();
    downloadFreeFile(gate.dataset.downloadUrl).then((delivery) => {
      publishFreeDownloadEvent("free_download_success", gate, { delivery });
      if (window.history?.replaceState) {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete("customer_posted");
        window.history.replaceState({}, "", `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
      }
    });
  }
});

// Progressive enhancement for direct free files only. The href remains usable
// without JS. Cross-origin CDN URLs need CORS + a local blob for download.
document.addEventListener("click", async (event) => {
  const link = event.target.closest?.("a[data-free-download]:not([data-free-download-fallback])");
  if (!link || event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!window.fetch || !window.AbortController || !window.URL?.createObjectURL ||
      !("download" in document.createElement("a"))) return;

  event.preventDefault();
  if (link.getAttribute("aria-busy") === "true") return;

  link.setAttribute("aria-busy", "true");
  try {
    await downloadFreeFile(link.href);
  } finally {
    link.removeAttribute("aria-busy");
  }
});


// Required consent for immediate delivery of tagged digital products.
// Products that require this flow must have the Shopify product tag: digital-consent

document.querySelectorAll("[data-cart-form][data-requires-digital-consent]").forEach((form) => {
  const checkbox = form.querySelector("[data-digital-consent-checkbox]");
  const checkoutButton = form.querySelector("[data-digital-consent-checkout]");
  const error = form.querySelector("[data-digital-consent-error]");
  const consentValue = form.querySelector("[data-digital-consent-value]");
  const consentLanguage = form.querySelector("[data-digital-consent-language]");
  const consentTimestamp = form.querySelector("[data-digital-consent-timestamp]");

  if (!checkbox || !checkoutButton) return;

  const syncConsentState = () => {
    const accepted = checkbox.checked;
    checkoutButton.disabled = !accepted;
    checkoutButton.setAttribute("aria-disabled", String(!accepted));

    [consentValue, consentLanguage, consentTimestamp].forEach((input) => {
      if (input) input.disabled = !accepted;
    });

    if (error && accepted) error.hidden = true;
  };

  checkbox.addEventListener("change", syncConsentState);

  checkoutButton.addEventListener("click", (event) => {
    if (!checkbox.checked) {
      event.preventDefault();
      if (error) error.hidden = false;
      checkbox.focus();
      return;
    }

    if (consentTimestamp) {
      consentTimestamp.value = new Date().toISOString();
    }
  });

  form.addEventListener("submit", (event) => {
    const submitter = event.submitter;
    if (submitter && submitter.name === "checkout" && !checkbox.checked) {
      event.preventDefault();
      if (error) error.hidden = false;
      checkbox.focus();
    }
  });

  syncConsentState();
});
